'use client';

import { createTheme } from '@mui/material/styles';
import { applyPrimaryColor } from './apply-primary-color';
import theme from './base';

const base = createTheme(theme, {
  palette: {
    background: {
      primary: '#f4fbea',
      gradient: {
        main: 'linear-gradient(to right, #5817bb80 0%, #5817bb 100%)',
        dark: 'linear-gradient(to right, #5817bb 0%, #5817bb80 100%)',
        light: 'linear-gradient(to right, #5817bb 0%, #5817bb80 100%)',
        contrastText: '#fff',
      },
    },

    primary: theme.palette.augmentColor({
      color: {
        main: '#5817bb80',
        contrastText: '#FFF',
      },
      name: 'primary',
    }),
    secondary: theme.palette.augmentColor({
      color: {
        main: '#5817bb',
        contrastText: '#FFF',
      },
      name: 'secondary',
    }),
  },
});

export const light = applyPrimaryColor(base);

export const dark = light;
